import { Edit, PostAdd } from '@material-ui/icons';
import { Box, Button, IconButton } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import React, { useEffect } from 'react';
import qs from 'qs';
import oikosApi from '../../../services/oikos';
import ModalFormulario from '../../../components/Modals/ModalFormulario/ModalFormulario';
import { Spinner } from 'reactstrap';
import { selectValues } from '../../../utils/fc';
import moment from 'moment';

const columns = [
  {
    accessorKey: 'tpFormulario_desc',
    header: 'Tipo',
    size: 100,
    accessorFn: (row) => {
      if (row.tpFormulario_desc) {
        return row.tpFormulario_desc;
      } else {
        return 'Sem Tipo';
      }
    },
  },
  {
    accessorKey: 'media_nota',
    header: 'Média',
    size: 100,
    accessorFn: (row) => {
      if (row.media_nota) {
        return Number(row.media_nota).toFixed(2);
      } else {
        return 'Sem Média';
      }
    },
  },
  {
    accessorKey: 'formulario_dtCria',
    header: 'Data',
    accessorFn: (row) => {
      if (row.formulario_dtCria) {
        return (new Date(row.formulario_dtCria)).getTime();
      } else {
        return null;
      }
    },
    size: 100,
    Cell: ({ cell, row }) => {
      if (row.original.formulario_dtCria) {
        return moment(row.original.formulario_dtCria).format('DD/MM/YYYY')
      }
    }, // Format Date for display
    filterVariant: 'range',
    sortingFn: 'datetime',
  },
  {
    accessorKey: 'proj_nome',
    header: 'Projeto',
    size: 600,
    accessorFn: (row) => {
      if (row.proj_nome) {
        return row.proj_nome;
      } else {
        return 'Sem Projeto';
      }
    },
  }
]

const ordenarPorLabel = (lista) => {
  console.log('lista', lista)
  return lista.sort((a, b) => {
    if (!a.label || !b.label) return 0;
    const labelA = a.label.toLowerCase();
    const labelB = b.label.toLowerCase();

    if (labelA < labelB) return -1;
    if (labelA > labelB) return 1;
    return 0;
  });
}

const PesquisaDeSatisfacao = () => {

  const [pesquisas, setPesquisas] = React.useState([]); // State to hold the list of questions
  const [isOpenModalNovaPesquisa, setIsOpenModalNovaPesquisa] = React.useState(false);
  const [isModalOpenningLoading, setIsModalOpenningLoading] = React.useState(false);
  const [perguntas, setPerguntas] = React.useState([]);
  const [selProjs, setSelProjs] = React.useState([]);
  const [selPfs, setSelPfs] = React.useState([]);
  const [defaultInputs, setDefaultInputs] = React.useState({});

  const fetchPesquisas = async () => {
    try {
      const res = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'formulario',
        data: {
          tpFormulario_id: 1,
          formulario_ativo: 1,
        },
        fields: {
          '(SELECT proj_nome FROM proj WHERE proj.proj_id = (SELECT formularioDado_resposta FROM formularioDado WHERE perguntaFormulario_id = 18 AND formulario_id = formulario.formulario_id))': 'proj_nome',
          '(SELECT tpFormulario_desc FROM tpFormulario WHERE tpFormulario_id = formulario.tpFormulario_id)': 'tpFormulario_desc',
          "(SELECT AVG(formularioDado_resposta) FROM formularioDado WHERE formularioDado.formulario_id = formulario.formulario_id AND formularioDado.perguntaFormulario_id NOT IN (18, 19) AND 'INT' = (SELECT perguntaFormulario_type FROM perguntaFormulario WHERE perguntaFormulario.perguntaFormulario_id = formularioDado.perguntaFormulario_id) GROUP BY formulario_id)": 'media_nota',
        },
      })}`);

      if (res.data.length > 0) {
        setPesquisas(res.data);
        console.log(res.data);
      }
    } catch (error) {
      console.log('Error fetching questions:', error);
    }
  }

  const fetchSelPfs = async () => {
    const resSelPfs = await selectValues('pf', 'pf_id', 'pf_nomeExibicao')
    console.log(resSelPfs.data);
    setSelPfs(resSelPfs);
  }

  const handleRowClick = async (row) => {
    setIsModalOpenningLoading(true);

    const res = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'perguntaFormulario',
      data: {
        tpFormulario_id: 1,
      },
    })}`);

    const resRespostas = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'formularioDado',
      data: {
        formulario_id: row.formulario_id,
      },
    })}`);

    const resFormularioSecundario = await oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'tpFormulario',
      data: {
        tpFormulario_mae: 1,
      },
    })}`);

    const resSelProjs = await selectValues('proj', 'proj_id', 'proj_nome')

    fetchSelPfs();

    let perguntasFinal = [];

    if (res.data.length > 0 && typeof(res.data) !== 'string') {
      for (const [index, pergunta] of res.data.entries()) {
        if (pergunta.formatoCampo_id === 1 && pergunta.perguntaFormulario_tabRef) {
          const selOptions = await selectValues(pergunta.perguntaFormulario_tabRef, `${pergunta.perguntaFormulario_tabRef}_id`, pergunta.perguntaFormulario_selectLabel)
          const selOptionsSorted = ordenarPorLabel(selOptions);
          res.data[index].selOptions = selOptionsSorted;

          if (resFormularioSecundario.data.length > 0 && typeof(resFormularioSecundario.data) !== 'string') {
            perguntasFinal = res.data.map((perguntaPrincipal) => {
              for (let index = 0; index < resFormularioSecundario.data.length; index++) {
                const element1 = resFormularioSecundario.data[index];
                const perguntasQueTemFormularioSecundario = res.data.filter((pergunta) => {
                  return perguntaPrincipal.perguntaFormulario_id === pergunta.perguntaFormulario_id && pergunta.perguntaFormulario_id === element1.perguntaFormulario_id
                });
                if (perguntasQueTemFormularioSecundario.length > 0) {
                  for (let index = 0; index < perguntasQueTemFormularioSecundario.length; index++) {
                    const element2 = perguntasQueTemFormularioSecundario[index];
                    return {...perguntaPrincipal, formSecundario: [element2.formSecundario ? [...element2.formSecundario, element1] : [element1]]}
                  }
                } else {
                  return perguntaPrincipal;
                }
              }
            })
          }
        } else if (pergunta.formatoCampo_id === 1 && !pergunta.perguntaFormulario_tabRef && pergunta.perguntaFormulario_opcoes) {
          // Parse the string into an object
          const obj = JSON.parse(pergunta.perguntaFormulario_opcoes);
          // Convert the object into the desired array format
          const arr = Object.entries(obj).map(([label, value]) => ({
            label,
            value
          })).sort((a, b) => a.value - b.value);;
          res.data[index].selOptions = arr;
        }
      }

      const respostasObj = {};
      const perguntasParaMapear = perguntasFinal && perguntasFinal.length > 0 ? perguntasFinal : res.data;
      
      if (resRespostas.data && resRespostas.data.length > 0) {
        resRespostas.data.forEach(resposta => {
          const pergunta = perguntasParaMapear.find(p => p.perguntaFormulario_id === resposta.perguntaFormulario_id);
          if (pergunta) {
            if (pergunta.formatoCampo_id === 4) {
               respostasObj[pergunta.perguntaFormulario_label] = Number(resposta.formularioDado_resposta);
            } else {
               respostasObj[pergunta.perguntaFormulario_label] = resposta.formularioDado_resposta;
            }
          }
        });
      }

      setPerguntas(perguntasParaMapear.sort((a, b) => a.perguntaFormulario_ord - b.perguntaFormulario_ord));
      setDefaultInputs(respostasObj);
      setSelProjs(resSelProjs);
      setIsModalOpenningLoading(false);
      setIsOpenModalNovaPesquisa(true);
    } else {
      setIsModalOpenningLoading(false);
    }

  }

  useEffect(() => {
    fetchPesquisas();
  }, [])

  return (
    <>
      <div style={{ padding: '20vh' }}>
        <h3>Página de Pesquisa de Satisfação</h3>
        <MaterialReactTable
          columns={columns}
          data={pesquisas}
          initialState={{
            density: 'compact',
            expanded: {}, //expand all groups by default
            pagination: { pageIndex: 0, pageSize: 50 },
            sorting: [], //sort by state by default
          }}
          enableGrouping={false}
          enableGlobalFilter={true}
          enableFilters={true}
          enablePagination={(pesquisas.length > 50)}
          muiTopToolbarProps={{
            sx: {
              '.button-fit-content': {'.MuiSvgIcon-root': {width: 'fit-content'}},
              '.MuiBox-root': {marginTop: "10px", height: "20px", display: "flex", alignItems: "center"},
              '.MuiSvgIcon-root': {width: '12px'},
              '.MuiButtonBase-root': {padding: '5px 5px 5px 5px'}
            }
          }}

          muiTableBodyCellProps={{sx: {fontSize: "13px"}}}
          muiTablePaginationProps={{
            sx: {'.MuiTablePagination-displayedRows': {fontSize: "12px"}, marginTop: "0px", fontSize: "12px"},
            labelRowsPerPage: <span style={{fontSize: "12px"}}>Produtos por página</span>,
            rowsPerPageOptions: [50, 100],
          }}
          muiTablePaperProps={{sx: {boxShadow: 'none'}}}
          positionPagination='top'
          muiTableHeadCellColumnActionsButtonProps={{size: "8px"}}
          enableDensityToggle={false}
          enableColumnFilters={false}
          muiTableHeadCellProps={{
            sx: {
              '.MuiSvgIcon-root': {fontSize: "18px"},
              fontSize: '12px',
              fontWeight: 'normal', // Remove bold text in the header
              padding: '8px', // Adjust padding to reduce white space
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            onClick: () => handleRowClick(row.original),
            sx: { cursor: 'pointer' },
          })}
        />
      </div>

      {selPfs && selProjs &&
        <ModalFormulario
          title="Respostas da Pesquisa de Satisfação"
          openModal={isOpenModalNovaPesquisa}
          onClosed={() => setIsOpenModalNovaPesquisa(false)}
          data={perguntas}
          size='lg'
          selProjs={selProjs}
          selPfs={selPfs}
          setSelProjs={setSelProjs}
          fetchSelPfs={fetchSelPfs}
          readOnly={true}
          defaultInputs={defaultInputs}
        />
      }

    </>
  );
};

export default PesquisaDeSatisfacao;
